import { useEffect } from 'react';
import './App.css';
import RouteConfig from './RouteConfig';
import LoadingMask from './components/Common/LoadingMask/LoadingMask';
import { getValidAccessToken } from './Services/oauthService';
import { useDispatch } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import ConfirmBox from './components/Common/ConfirmBox/Confirmbox';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import BlockBrowserBack from './BlockBrowserBack';

function App() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  useEffect(() => {
    const interceptorId = axios.interceptors.request.use((config) => {
      const requestUrl = config.url || '';
      const apiBaseUrl = process.env.REACT_APP_API_URL || '';
      const shouldAttachCurrentUrl =
        requestUrl.startsWith('/') || requestUrl.startsWith(apiBaseUrl);

      if (typeof window !== 'undefined' && shouldAttachCurrentUrl) {
        config.headers = {
          ...config.headers,
          'X-Current-Url': window.location.href,
        };
      }
      return config;
    });

    return () => {
      axios.interceptors.request.eject(interceptorId);
    };
  }, []);

  useEffect(() => {
    const initApp = async () => {
      await getValidAccessToken();

    dispatch({ type: 'domain/checkDomain' });

    // const partnerId = await fetchPartnerConfigInBackground();
    // await fetchPartnerSmsConfig(partnerId);

    // setIsloading(false);
  };

  initApp();
}, [dispatch]);

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);
  return (
    <>
    <ConfirmBox/>
      <LoadingMask />
      <BlockBrowserBack />
      <RouteConfig/>
     <Toaster />
    </>
  );
}

export default App;
